import { fetchClient } from "@/api/api";
import type {
	commonInput,
	commonOutput,
	overviewPageInput,
	overviewPageOutput,
} from "@/api/custom_types";
import type { CustomQueryHook } from "@/utils/react-query";
import { useQuery } from "@tanstack/react-query";
import { DASHBOARD_SERVICE_KEYS } from "./keys";

const useGetDashboardCommon: CustomQueryHook<commonOutput, commonInput> = (
	payload,
	options,
) => {
	return useQuery({
		...options,

		queryKey: DASHBOARD_SERVICE_KEYS.useGetDashboardCommon(payload),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET(
				"/v1/marketplace/dashboard/common/",
				{ params: { query: payload?.query }, throwOnError: true },
			);
			if (error) throw error;
			return data;
		},
	});
};

const useGetDashboardOverview: CustomQueryHook<
	overviewPageOutput,
	overviewPageInput
> = (payload, options) => {
	return useQuery({
		...options,
		queryKey: DASHBOARD_SERVICE_KEYS.useGetDashboardOverview(payload),
		queryFn: async () => {
			const { data, error } = await fetchClient.GET(
				"/v1/marketplace/dashboard/overview/",
				{ params: { query: payload?.query }, throwOnError: true },
			);
			if (error) throw error;
			return data;
		},
	});
};

export { useGetDashboardOverview, useGetDashboardCommon };
